import { render } from "./GetHeroSocialLinkItem.vue?vue&type=template&id=c3077cf0&scoped=true"
import script from "./GetHeroSocialLinkItem.vue?vue&type=script&lang=js"
export * from "./GetHeroSocialLinkItem.vue?vue&type=script&lang=js"

import "./GetHeroSocialLinkItem.vue?vue&type=style&index=0&id=c3077cf0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3077cf0"],['__file',"src/scripts/view/portfolio/common/hero/GetHeroSocialLinkItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3077cf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3077cf0', __exports__)) {
    api.reload('c3077cf0', __exports__)
  }
  
  module.hot.accept("./GetHeroSocialLinkItem.vue?vue&type=template&id=c3077cf0&scoped=true", () => {
    api.rerender('c3077cf0', render)
  })

}


export default __exports__